module.exports = __webpack_public_path__ + "static/media/a11.4f5a7db7.pdf";